const initialState = { me: {} }

export default (state = initialState, action) => {
  // TODO
  return state
}
